import { business } from "./business.js";
import { locations } from "./locations.js";
import { services } from "./services.js";

export const homePage = {
  kind: "home",
  path: "/",
  title: "Ménage hebdomadaire à domicile à Val d'Europe | Arklis",
  h1: "Votre ménage hebdomadaire à Val d'Europe.",
  description:
    "Arklis propose un service de ménage hebdomadaire à domicile à Val d'Europe pour les particuliers, notamment à Serris, Chessy et Montévrain.",
  primaryKeyword: "Ménage hebdomadaire à domicile à Val d'Europe"
};

export const servicePages = services.map((service) => ({
  kind: "service",
  ...service,
  title: `${service.title} | Arklis`,
  h1: service.title,
  description: `${service.summary} Service chaque semaine à Val d'Europe, Serris, Chessy, Montévrain et villes proches.`,
  primaryKeyword: service.title,
  breadcrumbs: [
    { label: "Accueil", path: "/" },
    { label: "Services", path: "/#services" },
    { label: service.shortTitle, path: service.path }
  ]
}));

export const localPages = locations.map((location) => ({
  kind: "local",
  ...location,
  primaryKeyword: `Ménage à domicile ${location.city}`,
  breadcrumbs: [
    { label: "Accueil", path: "/" },
    { label: "Zones d'intervention", path: "/#zone" },
    { label: location.city, path: location.path }
  ]
}));

export const notFoundPage = {
  kind: "not-found",
  path: "/404.html",
  title: "Page introuvable | Arklis",
  h1: "Page introuvable",
  description: "Cette page Arklis n'existe pas ou a été déplacée.",
  noindex: true
};

export const privacyPage = {
  kind: "privacy",
  path: "/politique-de-confidentialite/",
  title: "Politique de confidentialité | Arklis",
  h1: "Politique de confidentialité",
  description: "Politique de confidentialité du formulaire de contact Arklis et des demandes de ménage hebdomadaire.",
  breadcrumbs: [
    { label: "Accueil", path: "/" },
    { label: "Politique de confidentialité", path: "/politique-de-confidentialite/" }
  ]
};

export const seoPages = [homePage, ...servicePages, ...localPages, privacyPage];

export const routes = [...seoPages, notFoundPage];

export function normalizePath(pathname = "/") {
  const clean = pathname.split("?")[0].split("#")[0] || "/";
  if (clean === "/index.html") return "/";
  if (clean === "/404" || clean === "/404/") return "/404.html";
  if (clean === "/") return "/";
  if (clean.endsWith(".html")) return clean;
  return clean.endsWith("/") ? clean : `${clean}/`;
}

export function findPage(pathname) {
  const normalized = normalizePath(pathname);
  return routes.find((page) => page.path === normalized) || notFoundPage;
}

export function pageUrl(path) {
  const normalized = normalizePath(path);
  if (normalized === "/") return business.siteUrl;
  if (normalized === "/404.html") return `${business.siteUrl}/404.html`;
  return `${business.siteUrl}${normalized}`;
}
